import React, { useState, useEffect } from 'react';
import { List, Button, Modal, Form, Input, message, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

const CategoryManagement = () => {
  const [categories, setCategories] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    // 从 localStorage 加载分类
    const savedCategories = JSON.parse(localStorage.getItem('categories') || 'null');
    if (!savedCategories) {
      // 默认分类
      const defaultCategories = [
        { id: 'tools', name: '常用工具', key: 'tools' },
        { id: 'social', name: '社交媒体', key: 'social' },
        { id: 'learning', name: '学习资源', key: 'learning' },
        { id: 'video', name: '视频娱乐', key: 'video' },
        { id: 'shopping', name: '购物网站', key: 'shopping' }
      ];
      localStorage.setItem('categories', JSON.stringify(defaultCategories));
      setCategories(defaultCategories);
    } else {
      setCategories(savedCategories);
    }
  }, []);

  const showModal = (category = null) => {
    setEditingCategory(category);
    form.setFieldsValue(category || { name: '' });
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
    setEditingCategory(null);
  };

  const handleSubmit = (values) => {
    const newCategory = {
      id: editingCategory?.id || Date.now().toString(),
      name: values.name,
      key: editingCategory?.key || values.name.toLowerCase().replace(/\s+/g, '_')
    };

    let newCategories;
    if (editingCategory) {
      newCategories = categories.map(cat =>
        cat.id === editingCategory.id ? newCategory : cat
      );
      message.success('分类更新成功！');
    } else {
      newCategories = [...categories, newCategory];
      message.success('分类添加成功！');
    }

    localStorage.setItem('categories', JSON.stringify(newCategories));
    setCategories(newCategories);
    handleCancel();
  };

  const handleDelete = (category) => {
    // 检查是否有书签使用此分类
    const bookmarks = JSON.parse(localStorage.getItem('bookmarks') || '[]');
    const hasBookmarks = bookmarks.some(bookmark => bookmark.category === category.key);

    if (hasBookmarks) {
      message.error('该分类下还有书签，无法删除！');
      return;
    }

    const newCategories = categories.filter(cat => cat.id !== category.id);
    localStorage.setItem('categories', JSON.stringify(newCategories));
    setCategories(newCategories);
    message.success('分类删除成功！');
  };

  return (
    <div className="category-management">
      <div className="category-header">
        <h2>分类管理</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => showModal()}
        >
          添加分类
        </Button>
      </div>

      <List
        className="category-list"
        itemLayout="horizontal"
        dataSource={categories}
        renderItem={category => (
          <List.Item
            actions={[
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => showModal(category)}
              >
                编辑
              </Button>,
              <Popconfirm
                title="确定要删除这个分类吗？"
                description="删除后无法恢复，请确认该分类下没有书签。"
                onConfirm={() => handleDelete(category)}
                okText="确定"
                cancelText="取消"
              >
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                >
                  删除
                </Button>
              </Popconfirm>
            ]}
          >
            <List.Item.Meta
              title={category.name}
              description={`分类ID: ${category.key}`}
            />
          </List.Item>
        )}
      />

      <Modal
        title={editingCategory ? "编辑分类" : "添加分类"}
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={form.submit}
        okText="确定"
        cancelText="取消"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="name"
            label="分类名称"
            rules={[
              { required: true, message: '请输入分类名称！' },
              { min: 2, message: '分类名称至少2个字符！' },
              { max: 20, message: '分类名称最多20个字符！' }
            ]}
          >
            <Input placeholder="请输入分类名称" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CategoryManagement; 